export default __webpack_public_path__ + "public/assets/images/9fd9087f5a24c13e637bb3f9f80bec84.png";